import React, { lazy, Suspense } from 'react';

const LazyAboutPage = lazy(() => import('./ContactPage'));

const ContactPage = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyAboutPage {...props} />
  </Suspense>
);



export default ContactPage;
